import * as React from "react";
import type { SVGProps } from "react";
const SvgMorningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={348}
    height={348}
    fill="none"
    viewBox="0 0 348 348" {...props}
  >
    <path fill="#1D534F" d="M0 0h348v348H0z" />
    <rect
      width={88.475}
      height={88.475}
      x={181.471}
      y={182.156}
      fill="#ADEE79"
      rx={23.593}
    />
    <rect
      width={88.475}
      height={88.475}
      x={81.2}
      y={182.156}
      fill="#ADEE79"
      rx={23.593}
    />
    <path
      fill="#ADEE79"
      d="M246.34 170.364h-40.998c-20.493 0-31.252-24.321-17.467-39.485l40.998-45.097c14.514-15.965 41.073-5.698 41.073 15.879v45.097c0 13.038-10.569 23.606-23.606 23.606M81.2 146.762v-40.997c0-20.493 24.322-31.252 39.486-17.467l45.097 40.997c15.966 14.514 5.698 41.073-15.879 41.073h-45.097c-13.037 0-23.606-10.568-23.606-23.606"
    />
  </svg>
);
export default SvgMorningIcon;
